import { useState, useCallback } from 'react'

/**
 * Hook for managing copy-to-clipboard functionality
 *
 * @returns Object with copied state and copy function
 */
export const useCopyToClipboard = () => {
  const [copied, setCopied] = useState(false)

  const copy = useCallback(async (text: string) => {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (error) {
      console.error('Failed to copy to clipboard:', error)
      throw error
    }
  }, [])

  return { copied, copy }
}
